<template>
  <div class="carousel-element-wrapper">
    <!-- En-tête du composant (même habillage que les autres éléments) -->
    <div class="element-header">
      <span class="element-type-badge">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="7" y="4" width="10" height="16" rx="2"></rect>
          <path d="M3 8v8"></path>
          <path d="M21 8v8"></path>
        </svg>
        <span>Carrousel</span>
      </span>
      <div class="element-actions">
        <button class="action-btn" @click.stop="$emit('duplicate')" title="Dupliquer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
        </button>
        <button class="action-btn delete-btn" @click.stop="$emit('remove')" title="Supprimer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          </svg>
        </button>
      </div>
    </div>

    <div class="card">
      <!-- Texte principal -->
      <div class="message-section">
        <textarea
          v-model="localMessage"
          @blur="updateMessage"
          class="message-input"
          placeholder="Texte principal du carrousel… (ex : Voici nos nouveautés de la semaine)"
          rows="2"
          maxlength="1024"
        ></textarea>
        <span class="char-count" :class="{ 'char-count-limit': localMessage.length >= 1024 }">{{ localMessage.length }}/1024</span>
      </div>

      <!-- Réglages communs -->
      <div class="settings-row">
        <div class="segmented">
          <button type="button" :class="{ active: buttonMode === 'quick_reply' }" @click="setMode('quick_reply')">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
            Boutons de réponse
          </button>
          <button type="button" :class="{ active: buttonMode === 'cta_url' }" @click="setMode('cta_url')">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
            Bouton lien
          </button>
        </div>
        <div v-if="buttonMode === 'quick_reply'" class="segmented">
          <span class="segmented-label">Par carte</span>
          <button type="button" :class="{ active: buttonsPerCard === 1 }" @click="setButtonsPerCard(1)">1</button>
          <button type="button" :class="{ active: buttonsPerCard === 2 }" @click="setButtonsPerCard(2)">2</button>
        </div>
      </div>

      <!-- Le carrousel : navigation + ruban de cartes + points -->
      <div class="strip-wrap">
        <button class="strip-nav prev" :disabled="activeIndex <= 0" @click="scrollToCard(activeIndex - 1)" title="Carte précédente">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"></polyline></svg>
        </button>
        <button class="strip-nav next" :disabled="activeIndex >= localCards.length" @click="scrollToCard(activeIndex + 1)" title="Carte suivante">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"></polyline></svg>
        </button>

        <div class="cards-strip" ref="strip" @scroll.passive="onStripScroll">
          <div v-for="(card, cIdx) in localCards" :key="cIdx" class="wa-card" :class="{ focused: activeIndex === cIdx }">
            <!-- Barre de la carte : numéro, type de média, outils -->
            <div class="wa-card-toolbar">
              <span class="wa-card-index">{{ cIdx + 1 }}</span>
              <div class="media-type">
                <button type="button" :class="{ active: card.header_type !== 'video' }" @click="setHeaderType(cIdx, 'image')" title="En-tête image">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>
                  Image
                </button>
                <button type="button" :class="{ active: card.header_type === 'video' }" @click="setHeaderType(cIdx, 'video')" title="En-tête vidéo">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
                  Vidéo
                </button>
              </div>
              <div class="wa-card-tools">
                <button class="tool-mini" :disabled="cIdx === 0" @click="moveCard(cIdx, -1)" title="Déplacer à gauche">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"></polyline></svg>
                </button>
                <button class="tool-mini" :disabled="cIdx === localCards.length - 1" @click="moveCard(cIdx, 1)" title="Déplacer à droite">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"></polyline></svg>
                </button>
                <button class="tool-mini danger" :disabled="localCards.length <= 2" @click="removeCard(cIdx)" title="Supprimer la carte">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>
              </div>
            </div>

            <!-- Média -->
            <div class="wa-media" :class="{ empty: !card.media_url }" @click="uploadMedia(cIdx)">
              <video v-if="card.header_type === 'video' && card.media_url" :src="card.media_url" muted playsinline></video>
              <img v-else-if="card.media_url" :src="card.media_url" alt="Média de la carte" />
              <div v-else class="wa-media-placeholder">
                <span class="upload-circle">
                  <svg v-if="uploadingIndex !== cIdx" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                  <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" class="uploading-spinner"><circle cx="12" cy="12" r="10" opacity="0.3"></circle><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"></path></svg>
                </span>
                <span class="upload-label">{{ uploadingIndex === cIdx ? 'Envoi en cours…' : (card.header_type === 'video' ? 'Ajouter une vidéo' : 'Ajouter une image') }}</span>
                <span class="upload-sub">{{ card.header_type === 'video' ? 'MP4, 100 Mo max' : 'JPG ou PNG, 5 Mo max' }}</span>
              </div>
              <div v-if="card.media_url" class="wa-media-overlay">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>
                <span>Remplacer</span>
              </div>
            </div>
            <div class="wa-url-row">
              <button v-if="!urlOpen[cIdx]" type="button" class="link-btn" @click="toggleUrl(cIdx)">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
                {{ card.media_url ? 'Modifier l\'URL' : 'ou coller une URL publique' }}
              </button>
              <input
                v-else
                type="url"
                v-model="card.media_url"
                @blur="commitCards"
                class="wa-url"
                :placeholder="card.header_type === 'video' ? 'https://… .mp4' : 'https://… .jpg / .png'"
              />
            </div>

            <!-- Corps de la carte -->
            <div class="wa-body">
              <textarea
                v-model="card.body"
                @blur="commitCards"
                placeholder="Texte de la carte (optionnel)"
                rows="2"
                maxlength="160"
              ></textarea>
              <span class="char-count tiny" :class="{ 'char-count-limit': (card.body || '').length >= 160 }">{{ (card.body || '').length }}/160</span>
            </div>

            <!-- Boutons de la carte -->
            <div class="wa-buttons">
              <template v-if="buttonMode === 'quick_reply'">
                <div v-for="(btn, bIdx) in card.buttons" :key="bIdx" class="wa-button">
                  <input type="text" v-model="btn.title" @blur="commitCards" maxlength="20" :placeholder="'Libellé du bouton ' + (bIdx + 1)" class="wa-button-title" />
                  <div class="wa-button-link">
                    <span class="link-arrow" title="Bloc ouvert quand on tape ce bouton">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="9 10 4 15 9 20"></polyline><path d="M20 4v7a4 4 0 0 1-4 4H4"></path></svg>
                    </span>
                    <BlockSelector
                      class="compact-selector"
                      :value="blockValueFor(btn)"
                      :idBot="idBot"
                      :allowNoBlock="true"
                      placeholder="Vers quel bloc ?"
                      @change="onBlockChange(cIdx, bIdx, $event)"
                      @blocks-loaded="blocks = $event"
                    />
                  </div>
                </div>
              </template>
              <div v-else class="wa-button">
                <div class="wa-link-row">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
                  <input type="text" v-model="card.url_button.display_text" @blur="commitCards" maxlength="20" placeholder="Libellé du bouton" class="wa-button-title left" />
                </div>
                <input type="url" v-model="card.url_button.url" @blur="commitCards" placeholder="https://…" class="wa-url inline" />
              </div>
            </div>
          </div>

          <!-- Carte d'ajout -->
          <button class="wa-card add-card" :disabled="localCards.length >= 10" @click="addCard">
            <span class="upload-circle big">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            </span>
            <span class="upload-label">Ajouter une carte</span>
            <span class="upload-sub">{{ localCards.length >= 10 ? 'Maximum de 10 atteint' : (10 - localCards.length) + ' encore possible(s)' }}</span>
          </button>
        </div>

        <div class="strip-dots">
          <button v-for="(card, cIdx) in localCards" :key="'d' + cIdx" type="button" class="dot" :class="{ active: activeIndex === cIdx }" @click="scrollToCard(cIdx)" :title="'Carte ' + (cIdx + 1)"></button>
          <span class="dots-count">{{ localCards.length }}/10</span>
        </div>
      </div>

      <!-- État avant envoi -->
      <div v-if="problems.length" class="status warn">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
        <div>
          <div class="status-title">À compléter avant l'envoi</div>
          <ul><li v-for="(p, i) in problems" :key="i">{{ p }}</li></ul>
        </div>
      </div>
      <div v-else class="status ok">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="20 6 9 17 4 12"></polyline></svg>
        <div>Carrousel complet : {{ localCards.length }} cartes, {{ buttonMode === 'cta_url' ? 'un bouton lien' : buttonsPerCard + ' bouton(s) de réponse' }} par carte.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosPeelo } from '@/utils/axios'
import { apiBaseUrl } from '@/config'
import { consoleError } from '@/utils/logger'
import BlockSelector from '@/components/common/BlockSelector.vue'

const MIN_CARDS = 2;
const MAX_CARDS = 10;

function randomId(length = 15) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) result += characters.charAt(Math.floor(Math.random() * characters.length));
  return result;
}

function emptyButton() {
  return { id: randomId(), title: '' };
}

function emptyCard(buttonsPerCard = 1) {
  const buttons = [];
  for (let i = 0; i < buttonsPerCard; i++) buttons.push(emptyButton());
  return { header_type: 'image', media_url: '', body: '', buttons, url_button: { display_text: '', url: '' } };
}

// Normalise une carte venue de la base (anciens champs absents, boutons manquants…)
function normalizeCard(raw, buttonsPerCard) {
  const card = Object.assign(emptyCard(buttonsPerCard), raw || {});
  card.header_type = card.header_type === 'video' ? 'video' : 'image';
  card.url_button = Object.assign({ display_text: '', url: '' }, raw && raw.url_button ? raw.url_button : {});
  const buttons = Array.isArray(raw && raw.buttons) ? raw.buttons.map(b => Object.assign(emptyButton(), b || {})) : [];
  while (buttons.length < buttonsPerCard) buttons.push(emptyButton());
  card.buttons = buttons.slice(0, buttonsPerCard);
  return card;
}

export default {
  name: 'CarouselElement',
  components: { BlockSelector },
  props: {
    element: { type: Object, required: true },
    index: { type: Number, required: true },
    idBot: { type: String, default: '' }
  },
  data() {
    return {
      localMessage: '',
      localCards: [],
      buttonMode: 'quick_reply',
      buttonsPerCard: 1,
      blocks: [],
      uploadingIndex: null,
      urlOpen: {},
      activeIndex: 0
    };
  },
  computed: {
    problems() {
      const p = [];
      if (!this.localMessage.trim()) p.push('Le texte principal est obligatoire.');
      if (this.localCards.length < MIN_CARDS) p.push(`Il faut au moins ${MIN_CARDS} cartes.`);
      this.localCards.forEach((card, i) => {
        if (!card.media_url) p.push(`Carte ${i + 1} : ajoute une image ou une vidéo.`);
        if (this.buttonMode === 'cta_url') {
          if (!card.url_button.display_text || !card.url_button.url) p.push(`Carte ${i + 1} : texte et URL du bouton lien requis.`);
        } else if (card.buttons.some(b => !(b.title || '').trim())) {
          p.push(`Carte ${i + 1} : chaque bouton doit avoir un libellé.`);
        }
      });
      return p;
    }
  },
  mounted() {
    this.loadFromElement();
  },
  watch: {
    element: {
      deep: true,
      handler() {
        // Ne recharge que si la source diffère vraiment de l'état local (évite les boucles)
        if (JSON.stringify(this.serialize()) !== JSON.stringify(this.serializeFrom(this.element))) {
          this.loadFromElement();
        }
      }
    }
  },
  methods: {
    toggleUrl(cIdx) {
      this.urlOpen = { ...this.urlOpen, [cIdx]: !this.urlOpen[cIdx] };
    },
    cardStep() {
      const strip = this.$refs.strip;
      const first = strip && strip.querySelector('.wa-card');
      return first ? first.offsetWidth + 12 : 252;
    },
    onStripScroll() {
      const strip = this.$refs.strip;
      if (!strip) return;
      this.activeIndex = Math.max(0, Math.round(strip.scrollLeft / this.cardStep()));
    },
    scrollToCard(index) {
      const strip = this.$refs.strip;
      if (!strip) return;
      const target = Math.min(Math.max(index, 0), this.localCards.length);
      strip.scrollTo({ left: target * this.cardStep(), behavior: 'smooth' });
    },
    serializeFrom(el) {
      return {
        message: el.message || '',
        button_mode: el.button_mode === 'cta_url' ? 'cta_url' : 'quick_reply',
        cards: Array.isArray(el.cards) ? el.cards : []
      };
    },
    serialize() {
      return { message: this.localMessage, button_mode: this.buttonMode, cards: this.localCards };
    },
    loadFromElement() {
      this.localMessage = this.element.message || '';
      this.buttonMode = this.element.button_mode === 'cta_url' ? 'cta_url' : 'quick_reply';
      const rawCards = Array.isArray(this.element.cards) ? this.element.cards : [];
      const first = rawCards[0];
      this.buttonsPerCard = first && Array.isArray(first.buttons) && first.buttons.length >= 2 ? 2 : 1;
      let cards = rawCards.map(c => normalizeCard(c, this.buttonsPerCard));
      while (cards.length < MIN_CARDS) cards.push(emptyCard(this.buttonsPerCard));
      this.localCards = JSON.parse(JSON.stringify(cards));
    },
    emitChanges(changes) {
      this.$emit('update', { ...this.element, ...changes });
    },
    updateMessage() {
      if (this.localMessage !== (this.element.message || '')) this.emitChanges({ message: this.localMessage });
    },
    commitCards() {
      this.emitChanges({ cards: JSON.parse(JSON.stringify(this.localCards)), button_mode: this.buttonMode });
    },
    setMode(mode) {
      if (this.buttonMode === mode) return;
      this.buttonMode = mode;
      this.commitCards();
    },
    setButtonsPerCard(n) {
      if (this.buttonsPerCard === n) return;
      this.buttonsPerCard = n;
      this.localCards.forEach(card => {
        while (card.buttons.length < n) card.buttons.push(emptyButton());
        card.buttons = card.buttons.slice(0, n);
      });
      this.commitCards();
    },
    setHeaderType(cIdx, type) {
      this.localCards[cIdx].header_type = type;
      this.commitCards();
    },
    addCard() {
      if (this.localCards.length >= MAX_CARDS) return;
      this.localCards.push(emptyCard(this.buttonsPerCard));
      this.commitCards();
      this.$nextTick(() => this.scrollToCard(this.localCards.length - 1));
    },
    removeCard(cIdx) {
      if (this.localCards.length <= MIN_CARDS) return;
      this.localCards.splice(cIdx, 1);
      this.commitCards();
    },
    moveCard(cIdx, delta) {
      const target = cIdx + delta;
      if (target < 0 || target >= this.localCards.length) return;
      const [card] = this.localCards.splice(cIdx, 1);
      this.localCards.splice(target, 0, card);
      this.commitCards();
    },
    blockValueFor(btn) {
      if (!btn.id) return 'NO_BLOCK';
      const known = this.blocks.find(b => b.idblock === btn.id);
      return known ? btn.id : (this.blocks.length ? 'NO_BLOCK' : btn.id);
    },
    onBlockChange(cIdx, bIdx, selectedBlock) {
      if (!selectedBlock) return;
      const btn = this.localCards[cIdx].buttons[bIdx];
      if (selectedBlock._id === 'NO_BLOCK') {
        btn.id = randomId();
      } else {
        btn.id = selectedBlock.idblock;
        if (!(btn.title || '').trim()) {
          btn.title = (selectedBlock.blockname || selectedBlock.displayName || '').substring(0, 20);
        }
      }
      this.commitCards();
    },

    // ---- Téléversement du média d'une carte (image PNG/JPG ou vidéo MP4) ----
    uploadMedia(cIdx) {
      const isVideo = this.localCards[cIdx].header_type === 'video';
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = isVideo ? '.mp4,video/mp4' : '.png,.jpg,.jpeg,image/png,image/jpeg';
      fileInput.style.display = 'none';
      fileInput.addEventListener('change', (event) => this.handleUpload(event, cIdx, isVideo));
      document.body.appendChild(fileInput);
      fileInput.click();
      setTimeout(() => document.body.removeChild(fileInput), 1000);
    },
    async handleUpload(event, cIdx, isVideo) {
      const file = event.target.files[0];
      if (!file) return;
      const fileName = file.name.toLowerCase();
      const okType = isVideo
        ? (file.type === 'video/mp4' && fileName.endsWith('.mp4'))
        : (['image/jpeg', 'image/jpg', 'image/png'].includes(file.type) && ['.jpg', '.jpeg', '.png'].some(ext => fileName.endsWith(ext)));
      if (!okType) {
        this.$emit('notification', { message: isVideo ? 'Seuls les fichiers MP4 sont acceptés.' : 'Seuls les fichiers PNG, JPG et JPEG sont acceptés.', type: 'error' });
        return;
      }
      const maxSize = (isVideo ? 100 : 5) * 1024 * 1024;
      if (file.size > maxSize) {
        this.$emit('notification', { message: `Fichier trop volumineux (max ${isVideo ? 100 : 5} Mo).`, type: 'error' });
        return;
      }

      this.uploadingIndex = cIdx;
      try {
        const formData = new FormData();
        formData.append(isVideo ? 'videofromplayground' : 'imagefromplayground', file);
        const userData = localStorage.getItem('user');
        if (!userData) throw new Error('Session expirée, veuillez vous reconnecter');
        const token = JSON.parse(userData).data.token;
        const config = { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } };
        const response = await axiosPeelo.post(isVideo ? '/strong/upload/video/block' : '/strong/upload/image/block', formData, config);
        if (response.data && response.data.success) {
          const url = `${apiBaseUrl}/${response.data.filePath}`;
          await new Promise(resolve => setTimeout(resolve, isVideo ? 5000 : 2000));
          this.localCards[cIdx].media_url = url;
          this.commitCards();
        } else {
          throw new Error(response.data?.message || 'Erreur lors de l\'upload');
        }
      } catch (error) {
        consoleError('❌ Erreur upload média carrousel:', error);
        let message = 'Erreur lors de l\'upload';
        if (error.response?.status === 401) message = 'Session expirée, veuillez vous reconnecter';
        else if (error.response?.status === 413) message = 'Le fichier est trop volumineux';
        else if (error.message) message = error.message;
        this.$emit('notification', { message, type: 'error' });
      } finally {
        this.uploadingIndex = null;
      }
    }
  }
};
</script>

<style scoped>
/* ---- Habillage commun aux éléments du Playground ---- */
.carousel-element-wrapper {
  background: #ffffff;
  border-radius: 16px;
  overflow: visible;
  box-shadow: 0 10px 25px rgba(20, 48, 40, 0.08);
  border: 1px solid rgba(20, 48, 40, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-bottom: 20px;
}
.carousel-element-wrapper:hover {
  box-shadow: 0 15px 35px rgba(20, 48, 40, 0.12);
  border-color: rgba(218, 255, 209, 0.5);
  transform: translateY(-2px);
}
.element-header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 14px 20px; background: #143028;
  border-bottom: 1px solid rgba(218, 255, 209, 0.1);
  border-top-left-radius: 16px; border-top-right-radius: 16px;
}
.element-type-badge {
  display: flex; align-items: center; gap: 10px;
  font-size: 13px; font-weight: 700; color: #daffd1; text-transform: uppercase; letter-spacing: 0.05em;
}
.element-type-badge svg { color: #daffd1; }
.element-actions { display: flex; gap: 10px; }
.action-btn {
  background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(218, 255, 209, 0.15); cursor: pointer;
  width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center;
  color: rgba(218, 255, 209, 0.7); transition: all 0.25s ease;
}
.action-btn:hover { background: rgba(218, 255, 209, 0.1); color: #daffd1; border-color: #daffd1; transform: scale(1.05); }
.action-btn.delete-btn:hover { background: rgba(239, 68, 68, 0.1); color: #f87171; border-color: #ef4444; }

.card { padding: 0 0 14px; }

/* ---- Texte principal ---- */
.message-section { position: relative; padding: 14px 16px 8px; border-bottom: 1px solid #eef2ee; }
.message-input {
  width: 100%; padding: 12px; min-height: 56px; line-height: 1.5; color: #1f2937; font-family: inherit; font-size: 14px;
  border: 1px solid transparent; border-radius: 8px; background: transparent; resize: vertical; box-sizing: border-box;
}
.message-input:hover { background: rgba(20, 48, 40, 0.025); }
.message-input:focus { outline: none; border-color: rgba(20, 48, 40, 0.25); background: white; box-shadow: 0 0 0 3px rgba(218, 255, 209, 0.6); }
.char-count { position: absolute; right: 24px; bottom: 10px; font-size: 11px; color: #9ca3af; }
.char-count.tiny { right: 10px; bottom: 4px; font-size: 10px; }
.char-count-limit { color: #e53e3e; font-weight: 600; }

/* ---- Réglages ---- */
.settings-row { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; padding: 12px 16px 10px; }
.segmented { display: inline-flex; align-items: center; border: 1px solid rgba(20, 48, 40, 0.12); border-radius: 10px; overflow: hidden; background: #f6f9f6; }
.segmented button { display: inline-flex; align-items: center; gap: 6px; border: none; background: transparent; padding: 7px 12px; font-size: 12px; font-weight: 600; color: #143028; cursor: pointer; transition: all 0.2s; }
.segmented button.active { background: #143028; color: #daffd1; }
.segmented-label { padding: 0 10px; font-size: 10px; color: #143028; opacity: 0.6; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; }

/* ---- Le carrousel ---- */
.strip-wrap { position: relative; background: #f1f6f1; border-top: 1px solid #e6ede6; border-bottom: 1px solid #e6ede6; }
.strip-nav {
  position: absolute; top: 46%; z-index: 2; width: 32px; height: 32px; border-radius: 50%;
  background: #143028; color: #daffd1; border: 2px solid #ffffff; box-shadow: 0 6px 16px rgba(20, 48, 40, 0.25);
  display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s;
}
.strip-nav.prev { left: 6px; }
.strip-nav.next { right: 6px; }
.strip-nav:hover:not(:disabled) { transform: scale(1.08); }
.strip-nav:disabled { opacity: 0; pointer-events: none; }

.cards-strip {
  display: flex; gap: 12px; overflow-x: auto; padding: 16px 44px 10px;
  scroll-snap-type: x mandatory; scroll-padding-left: 44px; scrollbar-width: none;
}
.cards-strip::-webkit-scrollbar { display: none; }

.wa-card {
  flex: 0 0 240px; width: 240px; scroll-snap-align: start;
  background: #ffffff; border: 1px solid rgba(20, 48, 40, 0.08); border-radius: 14px;
  box-shadow: 0 4px 14px rgba(20, 48, 40, 0.06); display: flex; flex-direction: column; transition: box-shadow 0.25s, border-color 0.25s;
}
.wa-card.focused { border-color: rgba(20, 48, 40, 0.3); box-shadow: 0 8px 22px rgba(20, 48, 40, 0.12); }

.wa-card-toolbar { display: flex; align-items: center; gap: 6px; padding: 8px 8px 6px; }
.wa-card-index {
  width: 20px; height: 20px; border-radius: 50%; background: #143028; color: #daffd1; font-size: 11px; font-weight: 700;
  display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.media-type { display: inline-flex; border: 1px solid rgba(20, 48, 40, 0.12); border-radius: 8px; overflow: hidden; background: #f6f9f6; }
.media-type button { display: inline-flex; align-items: center; gap: 4px; border: none; background: transparent; font-size: 10px; font-weight: 700; padding: 4px 7px; color: #143028; cursor: pointer; }
.media-type button.active { background: #143028; color: #daffd1; }
.wa-card-tools { display: flex; gap: 3px; margin-left: auto; }
.tool-mini {
  width: 22px; height: 22px; border-radius: 6px; border: 1px solid transparent; background: transparent;
  color: #143028; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.2s; opacity: 0.55;
}
.tool-mini:hover:not(:disabled) { background: #daffd1; opacity: 1; }
.tool-mini:disabled { opacity: 0.15; cursor: not-allowed; }
.tool-mini.danger:hover:not(:disabled) { background: rgba(239, 68, 68, 0.1); color: #ef4444; }

.wa-media { position: relative; height: 136px; background: #eef3ee; cursor: pointer; overflow: hidden; }
.wa-media img, .wa-media video { width: 100%; height: 100%; object-fit: cover; display: block; }
.wa-media.empty { background: linear-gradient(160deg, #f4faf3 0%, #e4f3e0 100%); }
.wa-media-placeholder { height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; color: #143028; }
.upload-circle {
  width: 36px; height: 36px; border-radius: 50%; background: #ffffff; color: #143028; display: inline-flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 10px rgba(20, 48, 40, 0.12); margin-bottom: 4px; transition: transform 0.2s;
}
.upload-circle.big { width: 44px; height: 44px; }
.wa-media.empty:hover .upload-circle, .add-card:hover:not(:disabled) .upload-circle { transform: scale(1.08); background: #143028; color: #daffd1; }
.upload-label { font-size: 12px; font-weight: 700; }
.upload-sub { font-size: 10px; opacity: 0.55; }
.wa-media-overlay {
  position: absolute; inset: 0; background: rgba(20, 48, 40, 0.5); color: #daffd1; font-size: 12px; font-weight: 700;
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; opacity: 0; transition: opacity 0.2s;
}
.wa-media:hover .wa-media-overlay { opacity: 1; }

.wa-url-row { padding: 6px 10px 0; min-height: 22px; }
.link-btn { display: inline-flex; align-items: center; gap: 5px; border: none; background: transparent; font-size: 11px; color: #143028; opacity: 0.6; cursor: pointer; padding: 0; }
.link-btn:hover { opacity: 1; text-decoration: underline; }
.wa-url { width: 100%; padding: 6px 8px; font-size: 11px; border: 1px solid rgba(20, 48, 40, 0.2); border-radius: 6px; color: #374151; background: #fafcfa; box-sizing: border-box; }
.wa-url:focus { outline: none; border-color: #143028; background: white; }
.wa-url.inline { margin-top: 6px; }

.wa-body { position: relative; padding: 4px 10px 2px; }
.wa-body textarea {
  width: 100%; border: 1px solid transparent; border-radius: 6px; padding: 8px; font-size: 13px; line-height: 1.45; color: #1f2937;
  font-family: inherit; resize: none; background: transparent; box-sizing: border-box;
}
.wa-body textarea::placeholder { color: #9aa79d; font-style: italic; }
.wa-body textarea:hover { background: rgba(20, 48, 40, 0.025); }
.wa-body textarea:focus { outline: none; border-color: rgba(20, 48, 40, 0.25); background: white; }

.wa-buttons { border-top: 1px solid rgba(20, 48, 40, 0.08); padding: 8px 8px 10px; display: flex; flex-direction: column; gap: 6px; margin-top: auto; }
.wa-button {
  background: #daffd182; border: 1px solid rgba(20, 48, 40, 0.1); border-radius: 12px; padding: 6px 8px 8px;
  display: flex; flex-direction: column; gap: 4px; transition: all 0.25s;
}
.wa-button:hover { background: #c5f9b8; border-color: rgba(20, 48, 40, 0.2); }
.wa-button-title {
  width: 100%; border: none; background: transparent; font-size: 13px; font-weight: 700; color: #143028; text-align: center; padding: 3px 4px; box-sizing: border-box;
}
.wa-button-title.left { text-align: left; }
.wa-button-title::placeholder { color: rgba(20, 48, 40, 0.4); font-weight: 500; }
.wa-button-title:focus { outline: none; background: rgba(255, 255, 255, 0.7); border-radius: 6px; }
.wa-button-link { display: flex; align-items: center; gap: 4px; }
.link-arrow { color: #143028; opacity: 0.5; flex-shrink: 0; display: inline-flex; }
.wa-link-row { display: flex; align-items: center; gap: 6px; color: #143028; }

/* Sélecteur de bloc compacté dans les cartes */
.compact-selector { flex: 1; min-width: 0; }
.compact-selector :deep(.block-multiselect),
.compact-selector :deep(.block-multiselect .multiselect__tags) { min-height: 32px; }
.compact-selector :deep(.block-multiselect .multiselect__tags) { padding: 4px 28px 0 8px; border-radius: 8px; font-size: 12px; background: rgba(255, 255, 255, 0.75); }
.compact-selector :deep(.block-multiselect .multiselect__single),
.compact-selector :deep(.block-multiselect .multiselect__placeholder),
.compact-selector :deep(.block-multiselect .multiselect__input) { font-size: 12px; margin-bottom: 4px; padding-top: 0; }
.compact-selector :deep(.block-multiselect .multiselect__select) { height: 30px; width: 28px; }
.compact-selector :deep(.peelo-single-action-chip) { transform: none; padding: 2px 8px 2px 2px; gap: 6px; background: transparent; border: none; }
.compact-selector :deep(.peelo-single-icon) { width: 18px; height: 18px; }
.compact-selector :deep(.peelo-single-text .action-title) { font-size: 12px; }

.add-card {
  justify-content: center; align-items: center; gap: 4px; border: 2px dashed rgba(20, 48, 40, 0.2); background: rgba(255, 255, 255, 0.6);
  color: #143028; cursor: pointer; box-shadow: none; min-height: 300px;
}
.add-card:hover:not(:disabled) { border-color: #143028; background: rgba(218, 255, 209, 0.4); }
.add-card:disabled { opacity: 0.45; cursor: not-allowed; }

.strip-dots { display: flex; align-items: center; justify-content: center; gap: 6px; padding: 2px 16px 12px; }
.dot { width: 7px; height: 7px; border-radius: 50%; border: none; background: rgba(20, 48, 40, 0.2); cursor: pointer; padding: 0; transition: all 0.2s; }
.dot.active { width: 20px; border-radius: 4px; background: #143028; }
.dots-count { margin-left: 8px; font-size: 11px; color: #143028; opacity: 0.55; font-weight: 600; }

/* ---- État ---- */
.status { display: flex; gap: 10px; align-items: flex-start; margin: 12px 16px 0; padding: 10px 12px; border-radius: 10px; font-size: 12px; }
.status.warn { background: #fffdf7; border: 1px solid #f6e3a6; color: #8a5a00; }
.status.warn svg { color: #d99a00; flex-shrink: 0; margin-top: 1px; }
.status.ok { background: #f3fbf1; border: 1px solid rgba(20, 48, 40, 0.12); color: #143028; }
.status.ok svg { color: #143028; flex-shrink: 0; margin-top: 1px; }
.status-title { font-weight: 700; margin-bottom: 2px; }
.status ul { margin: 0; padding-left: 16px; }

.uploading-spinner { animation: spin 1s linear infinite; }
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
</style>
